(function () {

    angular
        .module('smartertoolsApp')
        .controller('hostedServicesController',
            [
                '$scope', '$timeout', 'hostingService', 'cacheControl', 'notificationFactory', '$window', 'payments',
                hostedServicesController
            ]);

    function hostedServicesController($scope, $timeout, hostingService, cacheControl, notify, $window, paymentsService) {
        const vm = this;
        vm.selectedService = null;
        vm.dateOnServer = Date.now();
        vm.selectedAgentCount = 5;

        // Functions
        vm.cancelSite = cancelSite;
        vm.changeAdminPassword = changeAdminPassword;
        vm.changePlan = changePlan;
        vm.endTrial = endTrial;
        vm.popup = popup;
        vm.refresh = refresh;
        vm.refreshInvoicesAndClosePayModal = refreshInvoicesAndClosePayModal;
        vm.resubscribeBeforeCancel = resubscribeBeforeCancel;
        vm.saveAdvancedOptions = saveAdvancedOptions;
        vm.savePaymentMethod = savePaymentMethod;
        vm.selectService = selectService;
        vm.setBindings = setBindings;
        vm.subscribe = subscribe;
        vm.updateCalculatedPriceChangeForUpgrade = updateCalculatedPriceChangeForUpgrade;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
        }

        function cancelSite() {
            vm.isProcessing = true;
            hostingService.cancelSite(vm.selectedService.ServiceID)
                .then(() => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                    hostingService.clearServiceCache();
                    vm.refresh();
                })
                .catch((err) => {
                    notify.error('There was a problem cancelling your site.  Please contact our sales team.');
                    vm.isProcessing = false;
                });
        };

        function changeAdminPassword() {
            if (vm.changeAdminPwForm.$invalid)
                return;
            vm.isProcessing = true;
            hostingService.resetAdminPassword(vm.selectedService.ServiceID, vm.selectedAdminUser, vm.newAdminPassword)
                .then(() => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                })
                .catch((err) => {
                    if (err.statusText)
                        notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                    else
                        notify.error('There was a problem saving your changes.');
                    vm.isProcessing = false;
                });
        };

        function changePlan() {
            vm.isProcessing = true;
            hostingService.changePlan(vm.selectedService.ServiceID, vm.selectedAgentCount)
                .then((data) => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                    hostingService.clearServiceCache();
                    vm.refresh();
                })
                .catch((err) => {
                    vm.isProcessing = false;
                    notify.error('There was a problem completing the transaction.  Please contact our sales team for assistance.');
                });
        }

        function endTrial() {
            vm.isProcessing = true;
            hostingService.endTrial(vm.selectedService.ServiceID)
                .then(() => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                    hostingService.clearServiceCache();
                    vm.refresh();
                })
                .catch((err) => {
                    notify.error('There was a problem ending your trial.  Please contact our sales team.');
                    vm.isProcessing = false;
                });
        };

        function popup(item, modal) {
            vm.selectedService = item;
            vm.selectedAgentCount = item.UserLimit;
            vm.modalPage = 'start';
            vm.isProcessing = false;
            switch (modal) {
                case 'hosted-services-change-admin-pw':
                    hostingService.getAdminUsers(item.ServiceID)
                        .then((adminUsers) => {
                            vm.adminUsers = adminUsers;
                            vm.newAdminPassword = vm.confirmAdminPassword = null;
                            vm.changeAdminPwForm.$setPristine();
                            vm.changeAdminPwForm.$setUntouched();
                            bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                            $timeout(() => RecalculateAllFloatLabelControls());
                        });
                    break;
                case 'hosted-services-advancedoptions':
                    vm.hostedAdvancedOptionsForm.$setPristine();
                    vm.hostedAdvancedOptionsForm.$setUntouched();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
                case 'hosted-services-subscribe':
                    vm.selectedPaymentMethod = {PaymentType: 'new'};
                    vm.subscribeForm.$setPristine();
                    vm.subscribeForm.$setUntouched();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
                case 'hosted-services-update-payment':
                    vm.selectedPaymentMethodForChange = {PaymentType: 'new'};
                    vm.paymentMethodForm.$setPristine();
                    vm.paymentMethodForm.$setUntouched();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
                case 'hosted-services-domains':
                    var temp = '';
                    for (var i = 0; i < vm.selectedService.Bindings.length; i++) {
                        if (temp != '')
                            temp += '\n';
                        temp += vm.selectedService.Bindings[i];
                    }
                    vm.newDomainBindings = temp;
                    vm.hostedDomainsForm.$setUntouched();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
                case 'hosted-services-changeplan':
                    vm.selectedAgentCount = vm.selectedService.UserLimit;
                    vm.hostedChangePlanForm.$setPristine();
                    vm.hostedChangePlanForm.$setUntouched();
                    vm.updateCalculatedPriceChangeForUpgrade();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
                default:
                    bootstrap.Modal.getOrCreateInstance(document.getElementById(modal)).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                    break;
            }
        };

        function refresh() {
            $scope.accountCtrl.isLoading++;
            hostingService.getServices()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.services = data.Services;
                    if (vm.services) {
                        for (var i = 0; i < vm.services.length; i++) {
                            var item = vm.services[i];
                            item.showBindingWarnings = item.Status == 'active' && item.BindingWarnings && item.BindingWarnings.length > 0;
                        }
                    }
                    vm.HasUnpaidInvoices = data.HasUnpaidInvoices;
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading--;
                });
        };

        function refreshInvoicesAndClosePayModal() {
            cacheControl.clearAllCaches();
            $window.location.reload();
        };

        function resubscribeBeforeCancel() {
            vm.isProcessing = true;
            hostingService.resubscribeBeforeCancel(vm.selectedService.ServiceID)
                .then((data) => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                    hostingService.clearServiceCache();
                    vm.refresh();
                })
                .catch((err) => {
                    vm.isProcessing = false;
                    notify.error('There was a problem completing the transaction.  Please contact our sales team for assistance.');
                });
        }

        function saveAdvancedOptions() {
            if (vm.hostedAdvancedOptionsForm.$invalid)
                return;
            vm.isProcessing = true;
            hostingService.saveAdvancedOptions(vm.selectedService.ServiceID, vm.selectedService.AdvancedOptions)
                .then(() => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                })
                .catch((err) => {
                    if (err.statusText)
                        notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                    else
                        notify.error('There was a problem saving your changes.');
                    vm.isProcessing = false;
                });
        }

        function savePaymentMethod() {
            vm.isProcessing = true;
            if (vm.selectedPaymentMethodForChange.PaymentType == 'card') {
                hostingService.savePaymentMethodExistingCard(vm.selectedService.ServiceID, vm.selectedPaymentMethodForChange)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isProcessing = false;
                        vm.modalPage = 'results';
                        hostingService.clearServiceCache();
                        vm.refresh();
                    })
                    .catch((err) => {
                        vm.isProcessing = false;
                        if (err.statusText)
                            notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                        else
                            notify.error('There was a problem saving your changes.');
                    });
            } else if (vm.selectedPaymentMethodForChange.PaymentType == 'new') {
                hostingService.savePaymentMethodNewCard(vm.selectedService.ServiceID, vm.selectedPaymentMethodForChange)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isProcessing = false;
                        vm.modalPage = 'results';
                        hostingService.clearServiceCache();
                        paymentsService.clearPaymentMethodsCache();
                        vm.refresh();
                    })
                    .catch((err) => {
                        vm.isProcessing = false;
                        if (err.statusText)
                            notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                        else
                            notify.error('There was a problem saving your changes.');
                    });
            } else if (vm.selectedPaymentMethodForChange.PaymentType == "invoice") {
                hostingService.savePaymentMethodNoCard(vm.selectedService.ServiceID)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isProcessing = false;
                        vm.modalPage = 'results';
                        hostingService.clearServiceCache();
                        vm.refresh();
                    })
                    .catch((err) => {
                        vm.isProcessing = false;
                        if (err.statusText)
                            notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                        else
                            notify.error('There was a problem saving your changes.');
                    });

            }
        };

        function selectService(item) {
            vm.selectedService = item;
        };

        function setBindings() {
            vm.isProcessing = true;
            hostingService.setBindings(vm.selectedService.ServiceID, vm.newDomainBindings)
                .then(() => {
                    vm.modalPage = 'results';
                    vm.isProcessing = false;
                    hostingService.clearServiceCache();
                    vm.refresh();
                })
                .catch((err) => {
                    if (err.statusText)
                        notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                    else
                        notify.error('There was a problem saving your changes.');
                    vm.isProcessing = false;
                });
        }

        function subscribe() {
            vm.isProcessing = true;
            if (vm.selectedPaymentMethod.PaymentType == 'card') {
                hostingService.subscribeExistingCard(vm.selectedService.ServiceID, vm.selectedAgentCount, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isProcessing = false;
                        vm.modalPage = 'results';
                        hostingService.clearServiceCache();
                        vm.refresh();
                    })
                    .catch((err) => {
                        vm.isProcessing = false;
                        if (err.statusText)
                            notify.error(`There was a problem making the payment.  ${err.statusText}`);
                        else
                            notify.error('There was a problem making the payment.');
                    });
            } else if (vm.selectedPaymentMethod.PaymentType === 'new') {
                hostingService.subscribeNewCard(vm.selectedService.ServiceID, vm.selectedAgentCount, vm.selectedPaymentMethod)
                    .then((result) => {
                        vm.paymentResult = result;
                        vm.isProcessing = false;
                        vm.modalPage = 'results';
                        hostingService.clearServiceCache();
                        vm.refresh();
                    })
                    .catch((err) => {
                        vm.isProcessing = false;
                        if (err.statusText)
                            notify.error(`There was a problem making the payment.  ${err.statusText}`);
                        else
                            notify.error('There was a problem making the payment.');
                    });
            }
        };

        function updateCalculatedPriceChangeForUpgrade() {
            vm.changePlanUpdating = true;
            hostingService.calculatePriceChangeForUpgrade(vm.selectedService.ServiceID, vm.selectedAgentCount)
                .then((data) => {
                    vm.changePlanMonthlyCost = data.NewMonthlyCost;
                    vm.changePlanUpgradeCost = data.UpgradeCost;
                    vm.changePlanUpdating = false;
                })
                .catch((err) => {
                    vm.changePlanMonthlyCost = null;
                    vm.changePlanUpgradeCost = null;
                    notify.error('There was a problem obtaining pricing information.  Please contact our sales team for assistance.');
                });
        };
    }

})();